<template>
  <div>
    <NewPermission @created="$emit('created')" />
    <ViewPermission
      :permission_id="permission_id"
      @updated="$emit('updated')"
    />
    <div class="row">
      <div class="col-auto">
        <v-btn
          v-if="permissions.permission_admin.write"
          class="v-primary mb-1"
          @click="$bvModal.show('new_permission')"
        >
          <span class="fa fa-plus"></span> Nova
        </v-btn>
      </div>
      <div class="col"><h6>Permissões</h6></div>
      <div class="col">
        <v-text-field
          v-model="permission_search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        />
      </div>
    </div>
    <div class="row">
      <ErrorsMessages :errors="errors" />
      <div class="col">
        <v-data-table
          dense
          :headers="permission_headers"
          :items="permission_items"
          :search="permission_search"
          :footer-props="{
            'items-per-page-options': [25, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          group-by="group_name"
          @click:row="openPermissionViewModal"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length" @click="toggle">
              <v-btn x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-plus</v-icon>
                <v-icon v-else>mdi-minus</v-icon>
              </v-btn>
              <span class="mx-2">{{ group.toUpperCase() }}</span>
            </td>
          </template>
          <template v-slot:[`item.write`]="{ item }">
            <i
              :class="`fa ${
                item.actions.write ? 'fa-check c-success' : 'fa-close c-danger'
              }`"
            ></i>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <i
              :class="`fa ${
                item.actions.edit ? 'fa-check c-success' : 'fa-close c-danger'
              }`"
            ></i
          ></template>
          <template v-slot:[`item.read`]="{ item }">
            <i
              :class="`fa ${
                item.actions.read ? 'fa-check c-success' : 'fa-close c-danger'
              }`"
            ></i
          ></template>
          <template v-slot:[`item.remove`]="{ item }"
            ><i
              :class="`fa ${
                item.actions.remove ? 'fa-check c-success' : 'fa-close c-danger'
              }`"
            ></i>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import NewPermission from "./NewPermission";
import ViewPermission from "./ViewPermission";
import ErrorsMessages from "../components/ErrorsMessages";

import api from "../../services/api";
import { adminData } from "../../lib/functions";

export default {
  name: "PermissionsList",
  components: {
    NewPermission,
    ViewPermission,
    ErrorsMessages,
  },
  props: {
    needs_refresh: Boolean,
  },
  watch: {
    needs_refresh: function (newValue) {
      if (newValue) {
        this.getPermissions();
        this.$emit("refreshed");
      }
    },
  },
  data() {
    return {
      permissions: {},
      errors: [],

      permission_search: "",
      permission_headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Grupo", value: "group_name" },
        { text: "Nome", value: "name" },
        { text: "Descrição", value: "description" },
        { text: "Alvo", value: "target" },
        { text: "Criar", value: "write" },
        { text: "Modificar", value: "edit" },
        { text: "Visualizar", value: "read" },
        { text: "Remover", value: "remove" },
      ],
      permission_items: [],
      permission_id: "",
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getPermissions();
  },
  methods: {
    async getPermissions() {
      try {
        this.loading = true;

        let response = await api.get("/admin/permissions");
        let { error, errors, permissions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.permission_items = permissions;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async openPermissionViewModal(item) {
      this.permission_id = item.id;
      this.$bvModal.show("view_permission");
    },
  },
};
</script>

<style>
</style>